export const MAX_PAGE_WIDTH_IN_PX = 960
export const MAX_CREATOR_WIDTH_IN_PX = 648
export const NAV_BAR_HEIGHT_IN_PX = 80

export const FOOTER_NAVBAR_ZINDEX = 10
